import { Div, CollectionPrinter } from '@tblabs/truffle';
import { Translations } from '../../Translations/Translations';
import { Row } from '../../Components/General/Row';
import { IoLogic } from '../IoLogic';
import { SensorBox } from './SensorBox';
import { TitleRow } from '../../Components/Snapshots/TitleRow';
import { AppSettings } from '../../Services/AppSettings';
import { SoundSwitch } from '../../Components/General/Buttons/SoundSwitch';


export class SensorsBox extends Div
{
    constructor(private _logic: IoLogic, private _lang: Translations, private _settings: AppSettings)
    {
        super("");
        this.MarginTop(16);
        this.Append(
            new TitleRow(this._lang.TouchSensors, new SoundSwitch(this._settings.SensorsSounds).FloatRight().MarginLeft(8).Color("#1e87f0").Style('transform: translateY(-2px);')),
            new Row(
                new CollectionPrinter(this._logic.Sensors, sensor => new SensorBox(sensor)),
            ).Class("sensors"),
        );
    }
}
